export const TEMPLATE_LIST_PAGE_SIZE = 10;
export const TEMPLATE_SUMMARY_PAGE_SIZE = 10;
export const TEMPLATE_USERS_PAGE_SIZE = 10;
export const OPTIN_PAGE_SIZE = 10;

export const TEMPLATE_BASE_PATH = '/r/v2/whatsapp-templates';

export function getSampleSheetUrl(waId) {
  return `${process.env.REACT_APP_API_URL}/v0/ui/whatsapp/download-template-sample-sheet/?id=${waId}`;
}

/** @deprecated Use templateReportingService.exportRecipients when USE_WHATSAPP_REPORTING is enabled. */
export function getUserSummaryDownloadUrl(templateId, sentDate) {
  return `${process.env.REACT_APP_API_URL}/v0/ui/mca-bot/download-template-user-summary/?template_id=${templateId}&date=${sentDate}`;
}
